export {
  default as OrderConfirmStaticDetails,
} from "./OrderConfirmStaticDetails";
export * as OrderConsignmentsBlock from "./OrderConsignmentsBlock";
export { default as OrderDataBlock } from "./OrderDataBlock";
export { default as OrderSummaryBlock } from "./OrderSummaryBlock";
export { default as PricingDetailsBlock } from "./PricingDetailsBlock";
export { default as LoyaltyPointsPopUpBlock } from "./LoyaltyPointsPopUpBlock";
export { default as LoyaltyBlock } from "./LoyaltyBlock";



// WEBPACK FOOTER //
// ./src/component/OrderConfirmComponents/index.js